function sendForm(form) {
    const collection = form.querySelectorAll('input, textarea')
    const preloader = document.querySelector('.popup-preloader')
    const orderGenerated = document.querySelector('.popup-order-generated')
    const errorGenerate = document.querySelector('.popup-warning')

    fetch(`${form.getAttribute('action')}`, {
        method: 'POST',
        body: data(collection, form)
    }).then(res => {
        $.fancybox.open(preloader)
        res.json()
    }).then(data => {
        setTimeout(() => $.fancybox.close(preloader), 1500)
        setTimeout(() => {
            if (data) {
                $.fancybox.open(orderGenerated)
                form.reset()
            } else {
                $.fancybox.open(errorGenerate)
            }
        }, 1700)
    }).catch(error => {
        setTimeout(() => $.fancybox.close(preloader), 1500)
        setTimeout(() => {
            $.fancybox.open(errorGenerate)
        }, 1700)
        console.log(error)
    })
}

function data(data, form) {
    let arr = []
    let formData = new FormData()
    data.forEach(inp => {
        arr.push(inp.getAttribute('name'))
    })
    for (let i = 0; i < arr.length; i++) {
        let key = arr[i]
        if (key === 'file') {
            Array.prototype.forEach.call(form.querySelector(`[name="${key}"]`).files, file => formData.append('file[]', file))
        } else {
            formData.append(key, new FormData(form).get(arr[i]))
        }
    }

    formData.append('product', form.querySelector('.Counter__title-text--bold').textContent)

    return formData
}